<script>
    import { createEventDispatcher, onMount } from 'svelte';
    const dispatch = createEventDispatcher();

    export let prompt;
    export let component = undefined;

    export let response = '';

    let input;

    function close(evt) {
        // console.log(evt);
        dispatch("close");
    }

    function save() {
        dispatch("save", response)
    }

  function key(evt) {
    if(evt.key == "Escape") close();
  }

  onMount(() => {
      if (input)
        input.focus()

  })
</script>

<style>
  .modal {
    z-index: 9999;
  }

  .modal-card-foot {
    justify-content: space-between;
  }
</style>

<form on:submit={save} on:keydown={key}>
  <div class="modal is-active">
    <div class="modal-background" on:click={close}></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{prompt}</p>
      </header>
      <slot>
        {#if component}
          <section class="model-card-body">
            <svelte:component this={component.component} {...component.data} />
          </section>
        {:else}
        <section class="modal-card-body">
          <input id="response_input" type='text' class='input' bind:value={response} bind:this={input}>
        </section>
        <footer class="modal-card-foot">
          <div class="button" on:click={close}>Cancel</div>
          <button class="button is-success" on:click={save}>Save</button>
        </footer>
        {/if}
      </slot>
    </div>
  </div>
</form>